<!--  -->
<template>
  <div>
    <div class="explain-name">
      <span>授信额度：</span>
      <span style="margin-right:2px;">¥</span>
      <span> {{moneyTrans(form.creditLine)}}</span>
    </div>
    <el-form
      ref="form"
      :model="form"
      label-width="80px"
      :inline="false"
      :rules="rules"
      class="demo-form-inline"
    >
      <el-form-item label="联系人">
        <el-input v-model="form.linkman"></el-input>
      </el-form-item>
      <el-form-item
        label="联系QQ"
        prop="qq"
      >
        <el-input v-model="form.qq"></el-input>
      </el-form-item>
      <el-form-item
        label="详细地址"
        class="address-list"
        prop="city"
      >
        <el-select
          v-model="form.province"
          placeholder="省"
          @change="handlerPovince"
        >
          <el-option
            v-for="provinceItem in provinceList"
            :key="provinceItem.region_code"
            :label="provinceItem.region_name"
            :value="provinceItem.region_code"
          />
        </el-select>
        <el-select
          v-model="form.city"
          placeholder="市"
          class="select-item"
          @change="changeCity"
        >
          <el-option
            v-for="cityItem in cityList"
            :key="cityItem.region_code"
            :label="cityItem.region_name"
            :value="cityItem.region_code"
          />
        </el-select>
        <el-select
          v-model="form.area"
          placeholder="区"
          class="select-item"
        >
          <el-option
            v-for="areaItem in areaList"
            :key="areaItem.region_code"
            :label="areaItem.region_name"
            :value="areaItem.region_code"
          />
        </el-select>
        <el-input
          class="input-item"
          v-model="form.detailAddress"
        ></el-input>
      </el-form-item>
      <el-form-item class="sub-item">
        <el-button
          type="primary"
          @click="onSubmit('form')"
          style="margin-right:10px;"
        >保 存</el-button>
        <el-button>取 消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { getAllInfo, updateBasicInfo } from "@/api/siter.js"
import areaJson from '@/api/getArea'
import { qqNumCheck } from "@/utils/validate.js"
import { formatMoney } from "@/api/dataTrans"
export default {
  data () {
    return {
      id: null,
      keyValue: 0,
      form: {
        id: null,
        name: null,
        region: '',
        email: null,
        linkMan: null,
        telephone: null,
        salesmanId: null,
        salesmanName: null,
        detailAddress: null,
        quantityLevel: null,
        straightChannelFlag: null,
        attributes: null,
        scale: null,
        creditLine: null,
        province: null,
        city: null,
        area: null
      },
      provinceList: [],
      cityList: [],
      areaList: [],
      rules: {
        linkman: [
          { required: true, message: '必选项不能为空', trigger: 'change' },
          { max: 20, message: '长度不能超过20', trigger: 'change' }
        ],
        qq: [
          { required: false, validator: qqNumCheck, trigger: 'blur' }
        ],
        area: [
          { required: true, message: '请选择', trigger: 'change' }
        ],

      }
    }
  },
  mounted () {
    // 获取所有省份
    this.provinceList = areaJson.data.items

    this.getBascInfo();
  },
  methods: {
    //获取用户基本信息
    getBascInfo () {
      getAllInfo({ trafficId: this.id }).then(res => {
        if (res.code == '0') {
          this.form = res.data.trafficUserNewVO
          this.handlerPovince(this.form.province, true)
        }
      })
    },
    //获取默认市区回填
    getDefaultCity (_val) {
      this.cityList.forEach(items => {
        if (items.region_code == _val) {
          this.areaList = items.children
          this.form.area = JSON.parse(JSON.stringify(this.form.area))
        }
      })
    },
    //省级列表选择监听
    handlerPovince (_val, _default) {
      this.provinceList.forEach(item => {
        if (item.region_code == this.form.province) {
          this.cityList = item.children
          // this.keyValue = item.region_code
          if (_default) {
            this.form.city = JSON.parse(JSON.stringify(this.form.city))
            this.getDefaultCity(this.form.city)
          } else {
            this.form.city = this.cityList[0].region_code
            this.areaList = this.cityList[0].children
            this.form.area = this.areaList[0].region_code
          }

          // console.log(JSON.stringify(this.form.city))
        }
      })
    },

    //市级列表选择监听
    changeCity () {
      console.log(JSON.stringify(this.form.city))
      this.cityList.forEach(item => {
        if (item.region_code == this.form.city) {
          this.areaList = item.children
          this.form.area = this.areaList[1].region_code
          console.log(JSON.stringify(this.form.area))
        }
      })
    },
    //初始化数据
    // initData (_obj) {
    //   console.log(JSON.stringify(_obj))
    //   this.form = _obj
    // },
    onSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          updateBasicInfo(this.form).then(res => {
            if (res.code == '0') {
              this.$message.success("更新成功")
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //货币格式转换
    moneyTrans (_val) {
      return formatMoney(_val)
    }
  }
}
</script>
<style lang='scss' scoped>
$iptHeight: 40px;
.explain-name {
  height: 32px;
  background: #fff7e6;
  border-radius: 4px;
  color: #d48806;
  font-size: 12px;
  line-height: 32px;
  padding-left: 16px;
}
.demo-form-inline {
  margin-top: 24px;
}
/deep/.el-form-item__content {
  width: 320px;
}
/deep/.el-form-item__label {
  height: $iptHeight !important;
  line-height: $iptHeight !important;
  font-size: 14px;
  color: rgba($color: #000000, $alpha: 0.85);
}
/deep/.el-input__inner {
  height: $iptHeight;
  line-height: $iptHeight;
}
/deep/.el-icon-arrow-up {
  height: $iptHeight !important;
}
/deep/.el-input__icon {
  line-height: $iptHeight;
}
.sub-item {
  margin-top: 24px;
}
/deep/.address-list {
  .el-form-item__content {
    width: auto;
  }
  .select-item {
    width: 120px;
    margin-right: 10px;
  }
  .input-item {
    width: 240px;
  }
}
</style>